import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import getBasketContainsSubscriptionProduct from '../../../v2/selectors/getBasketContainsSubscriptionProduct';
import getIsInApmExperiment from '../../../v2/selectors/PaymentOptionSelectors/ApmExperimentSelectors/getIsInApmExperiment';
import {getSettings} from '../../../v2/selectors/selectors';
import {isMobile} from '../../../v2/selectors/DeviceSelectors';
import GenericSection from '../../GenericSection/GenericSection';
import SubscriptionInformationSectionWrapper
from '../../SubscriptionInformationSection/SubscriptionInformationSectionWrapper';
import PaymentOptionSection from '../PaymentOptionsSection';

export function PaymentOptionSectionWrapper(props) {
  return (
    <div>
      <div data-test="PaymentOptionSection">
        <GenericSection
          {...props}
          id="payment-method-section-heading"
          headerKey={props.headerKey}
          isPaymentSection
        >
          <PaymentOptionSection isStepCollapsed={props.isStepCollapsed} />
        </GenericSection>
      </div>
  
      {props.outputSubscription && <SubscriptionInformationSectionWrapper />}
    </div>
  );
}

PaymentOptionSectionWrapper.propTypes = ({
  isStepActive: PropTypes.bool.isRequired,
  isStepCollapsed: PropTypes.bool.isRequired,
  headerKey: PropTypes.string.isRequired,
  outputSubscription: PropTypes.bool,
});

const mapStateToProps = state => ({
  headerKey: getIsInApmExperiment(state) ? 'checkout.payment.method.section.heading.text.apm.experiment' : 'checkout.payment.method.section.heading.text',
  outputSubscription: !isMobile(state) && getSettings(state)?.subscription_info_message_enabled && getBasketContainsSubscriptionProduct(state),
});

export default connect(mapStateToProps)(PaymentOptionSectionWrapper);
